module.exports = __webpack_public_path__ + "img/aims.a7964110.svg";